import React from 'react';
import FooterPageLayout from '../../components/layouts/FooterPageLayout';

const About = () => {
  return (
    <FooterPageLayout>
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-[#B22A2B] mb-4">About Pebble</h1>
          <p className="text-xl text-[#4A5568] max-w-2xl mx-auto">
            Finally, event organizing made simple. Let us handle the details while you focus on creating amazing experiences.
          </p>
        </div>
        
        <section className="mb-12 bg-white rounded-xl shadow-sm p-8 hover:shadow-md transition-shadow duration-300">
          <h2 className="text-2xl font-semibold text-[#B22A2B] mb-4">Our Mission</h2>
          <p className="text-[#4A5568] leading-relaxed mb-6">
            At Pebble, we make event organizing simple. We've thought through all the details so you can focus on creating great events. 
            Our platform helps you track revenue, increase earnings, and organize all your data and documents in one place. 
            No more spreadsheets - just more growth and opportunities to expand your events.
          </p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-semibold text-[#B22A2B] mb-6">What We Do</h2>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow duration-300 border border-[#E2E8F0]">
              <h3 className="font-semibold text-[#B22A2B] mb-2">Simplify Event Management</h3>
              <p className="text-[#4A5568]">
                We handle the complex parts of event organizing so you can focus on what matters most - creating memorable experiences for your attendees.
              </p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow duration-300 border border-[#E2E8F0]">
              <h3 className="font-semibold text-[#B22A2B] mb-2">Track Your Success</h3>
              <p className="text-[#4A5568]">
                Monitor your revenue, track vendor performance, and get insights to help you make better decisions for your events.
              </p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow duration-300 border border-[#E2E8F0]">
              <h3 className="font-semibold text-[#B22A2B] mb-2">Organize Everything</h3>
              <p className="text-[#4A5568]">
                Keep all your event documents, vendor information, and important data in one secure, easy-to-access place.
              </p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow duration-300 border border-[#E2E8F0]">
              <h3 className="font-semibold text-[#B22A2B] mb-2">Grow Your Events</h3>
              <p className="text-[#4A5568]">
                Access tools and insights that help you expand your events, attract more vendors, and increase your revenue.
              </p>
            </div>
          </div>
        </section>

        <section className="bg-white rounded-xl shadow-sm p-8 hover:shadow-md transition-shadow duration-300">
          <h2 className="text-2xl font-semibold text-[#B22A2B] mb-4">Get Started</h2>
          <p className="text-[#4A5568] leading-relaxed mb-6">
            Whether you're organizing your first event or managing multiple events, Pebble provides the tools you need to succeed. 
            Join us today and focus on what you do best - creating amazing events.
          </p>
          <div className="flex gap-4">
            <button 
              onClick={() => window.location.href = '/signup'} 
              className="bg-[#B22A2B] text-white px-6 py-3 rounded-lg hover:bg-[#8a2122] transition-colors font-medium"
            >
              Create Account
            </button>
            <button 
              onClick={() => window.location.href = '/contact'} 
              className="bg-white text-[#B22A2B] px-6 py-3 rounded-lg hover:bg-[#F7FAFC] transition-colors font-medium border border-[#B22A2B]"
            >
              Contact Us
            </button>
          </div>
        </section>
      </div>
    </FooterPageLayout>
  );
};

export default About; 